<template>
  <div id="report" style="height:100%;">
        <div class="table_searchbar">
            <el-row :gutter="W?20:0">
                <el-col :span="W?8:10">
                    <div class="" @keydown.enter="clickSearch()">
                        <span class="title">日期查询：</span>
                        <el-date-picker style="width:230px" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="W?16:14" >
                    <div style="text-align:right">
                        <el-button icon="el-icon-search" size='mini' type="primary" @click="clickSearch(1)">查询</el-button>
                        <el-button icon="el-icon-download" size='mini'  @click="exportList" v-if="permission.btn_report_exportDevice">导出</el-button>
                        <el-button  size="mini"  @click='printOrderInfo'>打印报表</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row class='tab'>
            <el-row class='table-wrap'  >
                <div style="margin-top:30px;">
                    <el-table :data="orderList"    width=80%  class="table_data"   border>
                        <el-table-column fixed prop="deviceCode" label="设备编号" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="deviceName" label="设备名称" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="workDays" label="工作天数" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="stopTimeSpan" label="停机时长" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="activation" label="计划稼动率"  :formatter="parseRatio" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="maintenanceAmount" label="保养次数" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed prop="repairAmount" label="维修次数" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
            </el-row>
            <div class="page" v-if="page.isShow">
                <div class="total_page"><span> 共{{page.total}}条 </span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                    <el-pagination background @size-change="sizeChange" layout=" sizes, prev, pager, next, jumper" :page-count="page.total"
                    :page-sizes="[10, 20, 30, 50,100]" :page-size.sync="page.pageSize"  :total="page.total" @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                </div>
            </div> 
        </el-row>
    </div>
</template>

<script>
import PrintReport from "./PrintReport.vue";
export default {
    name: "MaintenanceOrderReport",
    components:{PrintReport},
    data() {
        return {
            fristLoad:false,
            activeName:'0',
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            W:false,
            searchForm:{},
            dateRange: [new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000), new Date()],
            orderList:[],
            viewData:[],
            permission:JSON.parse(localStorage.getItem("permission"))  
        };

    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    mounted: function() {
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.init();
    },
    methods: {
        //加载打印数据
        async loadPrintData(){
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }
            let [startDate,endDate] = dateRange
            startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true)
            endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true)
            let {data} =await this.$RequestUtil.getAsync({url: '/api/report/listDevice',type: 'sync',params: {startDate, endDate},})
            return data
        },
        //打印订单
        async printOrderInfo(row){
            let data = await this.loadPrintData(row.splitItemId)
            let arr = [
                {key:'deviceCode',value:'设备编号'},
                {key:'deviceName',value:'设备名称'},
                {key:'workDays',value:'工作天数'},
                {key:'stopTimeSpan',value:'停机时长'},
                {key:'activation',value:'计划稼动率'},
                {key:'maintenanceAmount',value:'保养次数'},
                {key:'repairAmount',value:'维修次数'},
            ]
            data.forEach(item=>{
                item.activation = this.parseRatio(item)
            })
            let str = commonUtils.createTable(arr,data)
            this.$nextTick(()=>{
                var printWindow = window.open(""); //新打开一个空窗口
                printWindow.document.body.innerHTML = str
                printWindow.document.close(); //在IE浏览器中使用必须添加这一句
                printWindow.focus(); //在IE浏览器中使用必须添加这一句
                setTimeout(()=>{
                    printWindow.print(); //打印
                    printWindow.close(); //关闭窗口
                }, 0);
            })
        },
        sizeChange(ev){
           this.$set(this.page,'pageSize',ev)
            this.search();
        },
        init: function() {
            this.search();
        },
        exportList: function() {
            let dateRange = this.dateRange;
            log(this.dateRange)
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return
            }

            this.export();
        },
        clickSearch: function() {
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return
            }
            this.search(1);
        },
        pageChange(pageNum) {
            this.search(pageNum);
        },
        //清空查询条件
        clearSearch(){
            
        },
        export: function() {
            this.$confirm('是否确认导出?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let dateRange = this.dateRange;
                let [startDate,endDate] = dateRange
                startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true)
                endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true)
                let params = {
                    startDate,
                    endDate,
                }
                let str = '?'
                for(let p in params){

                    if(params[p]||params[p]===0){
                        str += `${p}=${params[p]}&`
                    }
                }
                let {code,data} = await this.$RequestUtil.getAsync({url: "/api/auth/checkToken",type:'sync',params: {},})
                if(data==0||(code!=0)){
                    this.$message.error('当前登录已过期')
                    localStorage.removeItem("token");
                    localStorage.removeItem("username");
                    localStorage.removeItem("permission");
                    this.$router.push({path:"/login"})
                    return 
                }  
                if(str.endsWith('&')){
                    str = str.slice(0,str.length-1)
                    str+=`&token=${localStorage.getItem("token")}`
                    window.location.href = '/api/report/exportDevice'+str;
                }
            }).catch(() => {});
        },
        search:function(pageNum){
            if(pageNum == null || pageNum instanceof KeyboardEvent){
                pageNum = 1;
            }
            this.page.currentPage = pageNum
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }
            let [startDate,endDate] = dateRange
            this.$RequestUtil.get({
                url:'/api/report/listDevice', 
                type:'sync',
                params: {
                    startDate,
                    endDate,
                    pageNum: pageNum,
                    pageSize: this.page.pageSize,
                },
                success: (res) => {
                    if(res.code == 0){
                        this.orderList = res.data;
                        this.page.total = res.totalPages;
                        if(res.totalPages == 0 && this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        parseOrderDate:function(time){
            if(time != null){
                let dateString = commonUtils.timestampToDate(time.orderTime,true);
                return dateString;
            }
        },
        parseRatio:function(rowData){
            if(rowData.activation != null){
                return rowData.activation+'%';
            }
        },
       
        parseCount(rowData){
            if(!rowData.count){
                return 0
            }else{
                return rowData.count
            }
        }
    }
};
</script>

<style scoped>
/* .warp{
    overflow: hidden;
    height: 100%;
    width: 100%;
} */
#report{
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    scrollbar-width: none;
}
#report::-webkit-scrollbar {
        display: none;
    } 

.search-input-row{
    margin-top: 10px;
}
.page{
    display: flex;
    justify-content: flex-end;
}
.total_page{
    margin-top: 16px;
    margin-right: 16px;
    color:#606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }
/* .tabs .el-tabs__item{
    font-size:18px;
    text-align:left;
    width:112px;
}
.tabs .el-tabs__nav{
    width:100%;
    display:flex;
    justify-content: space-around;
}
.tabs .el-tabs__nav-wrap::after{
    height: 0;
}
.tabs .el-tabs__active-bar{
    width:72px;
    height: none;
} */
/* .tabs .el-tabs__nav-wrap::after{
    height: 0;
} */
/* .tabs  .el-tabs__active-bar{
    height: 0px;
}
.tabs  .is-active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #409EFF;
    z-index: 1;

}
.tabs .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
} */
</style>




// WEBPACK FOOTER //
// src/views/report/maintenanceOrderReport.vue